import { CartItemChangeAlertProps } from '@jbhi-fi/components/src/Cart/CartItemChangeAlert/CartItemChangeAlert';

export const getCartItemChangeAlert = (item: Record<string, any>) => {
  const {
    _priceAtc: addedToCartPrice,
    _marketplaceSeller: currentSellerName,
    _marketplaceSellerId: currentSellerId,
    _marketplaceSellerIdAtc: addedToCartSellerId,
  } = item.properties;

  const hasPriceIncreased = !!addedToCartPrice && item.final_line_price > Number(addedToCartPrice) * item.quantity;
  const hasSellerChanged = addedToCartSellerId && addedToCartSellerId !== currentSellerId;

  let variant: CartItemChangeAlertProps['variant'] | undefined = undefined;
  if (hasSellerChanged) {
    variant = 'seller';
  } else if (hasPriceIncreased) {
    variant = 'price';
  } else if (item.isNoLongerAvailable) {
    variant = 'noLongerAvailable';
  }

  const priceVariant: CartItemChangeAlertProps['priceVariant'] | undefined = hasPriceIncreased ? 'increase' : undefined;

  return {
    variant,
    priceVariant,
    currentSellerName,
  };
};
